<template>
  <div
    :style="{
      '--primary-color': tenant ? tenant.primaryColor : '#fff',
      '--secondary-color': tenant ? tenant.secondaryColor : '#fff'
    }"
  >
    <prompt-pwa></prompt-pwa>
    <router-view></router-view>
  </div>
</template>

<script>
import { PromptPwa } from "@/components";
export default {
  components: {
    PromptPwa
  }
};
</script>

<style>
.badge {
  color: #fff;
  display: inline-block;
  font-size: 12px;
  padding: 8px 10px;
  width: 9rem;
  text-align: center;
}

.badge-red {
  background-color: #e94340;
}

.badge-yellow {
  background-color: #ebdd66;
}

.badge-green {
  background-color: #51bd61;
}
</style>
